module.exports = ng.material.card;